import React, { useRef } from "react";
import { motion, useInView, useAnimation } from "framer-motion";
import HeroSection from "../../components/HeroSection";
import { FaDownload, FaFilePdf } from "react-icons/fa";
import groupEventAsset from "../../assets/gallery/events/groupix.png";
import { getCollageImages } from "../../utils/heroImages";

const AnimatedSection = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const controls = useAnimation();

  if (isInView) {
    controls.start("visible");
  }

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 }
      }}
      transition={{ duration: 0.6, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default function Newsletters() {
  const groupEvent = `${groupEventAsset}?v=20260424`;
  const newsletters = [
    { month: "April 2024", title: "Spring Newsletter 2024", available: true },
    { month: "March 2024", title: "March Newsletter 2024", available: true },
    { month: "February 2024", title: "February Newsletter 2024", available: true },
    { month: "January 2024", title: "January Newsletter 2024", available: true }
  ];

  return (
    <div className="w-full bg-white">
      <HeroSection
        title="Newsletters"
        subtitle="Stay connected with our community through our monthly newsletters featuring updates, stories, and highlights."
        buttons={[
          { text: "Apply Now", link: "/register", variant: "blue" },
          { text: "Login", link: "/login", variant: "blue" }
        ]}
        collageImages={getCollageImages("newsletters")}
      />

      {/* Introduction */}
      <section className="section bg-white">
        <div className="section-container">
          <AnimatedSection>
            <div className="max-w-4xl mx-auto text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
                Stay Informed
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                Our newsletters keep you updated on our programs, events, success stories, and community news.
              </p>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* Newsletters List */}
      <section className="section bg-gray-50">
        <div className="section-container">
          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {newsletters.map((newsletter, index) => (
              <AnimatedSection key={index} delay={0.2 + index * 0.1}>
                <div className="card">
                  <div className="flex items-center gap-4 mb-4">
                    <FaFilePdf className="text-4xl text-primary-600" />
                    <div>
                      <h3 className="text-xl font-bold text-gray-800">{newsletter.title}</h3>
                      <p className="text-gray-600">{newsletter.month}</p>
                    </div>
                  </div>
                  <button className="btn-primary flex items-center gap-2">
                    <FaDownload />
                    Download
                  </button>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
